import { ArrowBack, ArrowForward } from '@mui/icons-material'
import { Box, IconButton, Typography } from '@mui/material'
import { GRADUATION_MONTHS } from './profile.constants'
import {
  graduationYearMax,
  graduationYearMin,
  isGraduationMonthEnabled,
} from './profile-steps'

export function GraduationPicker({
  year,
  month,
  onChange,
}: {
  year: number
  month: number | null
  onChange: (year: number, month: number | null) => void
}) {
  function changeYear(nextYear: number) {
    const nextMonth =
      month != null && !isGraduationMonthEnabled(nextYear, month) ? null : month
    onChange(nextYear, nextMonth)
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2.5,
        }}
      >
        <IconButton
          aria-label="Ano anterior"
          disabled={year <= graduationYearMin}
          onClick={() => changeYear(year - 1)}
        >
          <ArrowBack />
        </IconButton>
        <Typography variant="h5" sx={{ fontVariantNumeric: 'tabular-nums' }}>
          {year}
        </Typography>
        <IconButton
          aria-label="Próximo ano"
          disabled={year >= graduationYearMax}
          onClick={() => changeYear(year + 1)}
        >
          <ArrowForward />
        </IconButton>
      </Box>

      <Box
        role="group"
        aria-label="Mês de formatura"
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 1,
        }}
      >
        {GRADUATION_MONTHS.map((label, index) => {
          const selected = month === index
          const disabled = !isGraduationMonthEnabled(year, index)
          return (
            <Box
              key={label}
              component="button"
              type="button"
              aria-pressed={selected}
              disabled={disabled}
              onClick={() => onChange(year, index)}
              sx={{
                minHeight: 44,
                borderRadius: 1.25,
                border: '1px solid',
                borderColor: selected ? 'primary.main' : 'divider',
                bgcolor: selected ? 'primary.main' : 'background.paper',
                color: selected ? 'primary.contrastText' : 'text.primary',
                fontWeight: 500,
                font: 'inherit',
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.35 : 1,
              }}
            >
              {label}
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
